module.exports = __webpack_public_path__ + "img/background-image.8998a2ae.svg";